import React, { useState, useEffect } from "react";
import principal from "../../assets/principal.jpeg";
import leftQuote from "../../assets/quote (1).png";
import rightQuote from "../../assets/left (1).png";
import cmsApi from "../../services/cmsApi";
import { getImageUrl } from "../../utils/getImageUrl";

const PhilosophySection = () => {
  const [philosophyData, setPhilosophyData] = useState({
    heading: "Message From Principal",
    message: "JRIIT is guided by a well-defined philosophy and core values. The Institute's philosophy is to become an agent of change in the public and private sectors by offering quality, market-driven academic and professional training and consultancy services. Our core values include customer focus, academic freedom, accountability, competence, excellence, fairness, gender equity, and diversity, as well as integrity.",
    signature: "Mr. Lukumay",
    image: principal,
  });

  // Fetch philosophy content from CMS (client-side only)
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const fetchPhilosophyContent = async () => {
      try {
        const result = await cmsApi.getHomepageComponentByType('philosophy');
        if (result.success && result.components.length > 0) {
          const philosophy = result.components[0];
          const settings = philosophy.settings || {};
          
          const defaultMessage = "JRIIT is guided by a well-defined philosophy and core values. The Institute's philosophy is to become an agent of change in the public and private sectors by offering quality, market-driven academic and professional training and consultancy services. Our core values include customer focus, academic freedom, accountability, competence, excellence, fairness, gender equity, and diversity, as well as integrity.";
          
          setPhilosophyData({
            heading: philosophy.title || "Message From Principal",
            message: philosophy.content || defaultMessage,
            signature: settings.principalName || "Mr. Lukumay",
            image: philosophy.mediaUrl || principal,
          });
        }
      } catch (error) {
        console.log('Using default philosophy content:', error.message);
      }
    };

    fetchPhilosophyContent();
  }, []);

  return (
    <section className="flex justify-center bg-custom-pink p-8 lg:p-24 text-white min-[1024px]:max-[1535px]:!p-10">
      <div className="flex flex-col md:flex-row items-center mx-auto justify-between w-full lg:max-w-[1400px]">
        {/* Left Side: Image */}
        <div className="md:w-1/2 w-full relative">
          <img
            src={leftQuote}
            alt="Left Quote"
            className="absolute top-0 left-0 w-8 h-8 md:w-12 md:h-12 lg:w-28 lg:h-28 -translate-x-0 -translate-y-16"
          />
          <img
            src={getImageUrl(philosophyData.image)}
            alt="Principal"
            className="w-full lg:w-[calc(110%)] h-auto lg:aspect-[550/371] object-cover rounded-[20px] mb-12 md:mb-0"
            onError={(e) => {
              console.error('Failed to load principal image:', philosophyData.image);
              e.currentTarget.src = principal;
            }}
          />
        </div>

        {/* Right Side: Text */}
        <div className="lg:mt-24 lg:mr-8 text-black relative md:w-1/2 w-full">
          <div
            className="relative mt-12 lg:mt-0 p-8 lg:p-12 w-full lg:w-[calc(100%)] lg:aspect-[550/371] bg-white rounded-[20px] flex flex-col justify-center min-[1024px]:max-[1535px]:!p-6"
            style={{ transform: "translateX(-12.5px)" }}
          >
            {/* Section Heading */}
            <h2 className="text-2xl lg:text-3xl font-bold text-pink-700 mb-6 min-[1024px]:max-[1535px]:!text-xl min-[1024px]:max-[1535px]:!mb-4">
              {philosophyData.heading}
            </h2>

            {/* Paragraph */}
            <p className="text-lg leading-relaxed tracking-wide mb-6 min-[1024px]:max-[1535px]:!text-base min-[1024px]:max-[1535px]:!mb-4">
              {philosophyData.message}
            </p>

            {/* Signature */}
            <h3 className="font-bold text-pink-700 text-xl text-right">
              {philosophyData.signature}
            </h3>

            {/* Right quote */}
            <img
              src={rightQuote}
              alt="Right Quote"
              className="absolute bottom-0 right-0 w-8 h-8 md:w-12 md:h-12 lg:w-28 lg:h-28 translate-x-0 translate-y-16"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
